import { getCommonEnv, lasterVersion } from '@/js/utils';
const env = getCommonEnv();
let callbackId = 100000;// 客户端只接受 数字安卓最大10位数。为什么从100000开始是因为之前业务有写死的callbackId.怕重复
export const nativeFnStore = {};

function onNativeCall(result) {
    const parse_result = JSON.parse(result);
    const { method, data, callbackId } = parse_result;
    if (data) {
        nativeFnStore[method + callbackId] && nativeFnStore[method + callbackId](parse_result);
    }
}

window.onNativeCall = onNativeCall;


export const newCallNative = function (params = {
    method: '', // 必填
    version: '4.0.0', // 必填
    data: {}, // 选填
}) {
    let { method, version, data } = params;
    if (!method || !version) {
        console.error(`请指定method和version参数`);
        return;
    }
    callbackId++;
    if (callbackId > 2147483647) {
        callbackId = 100000;
    }
    if (!data) {
        data = {};
    }
    return new Promise((resolve, reject) => {
        let key = method + callbackId;

        nativeFnStore[key] = function (res) {
            resolve(res);
        };
        if (env.isKooAppAndroid && lasterVersion(version)) {
            try {
                window.koosdk.exec(JSON.stringify({
                    method,
                    callbackId,
                    data
                }));
            } catch (error) {
                reject(error);
            }

        } else if (env.isKoouAppIos && lasterVersion(version)) {
            try {
                window.webkit.messageHandlers.koosdk.postMessage(JSON.stringify({
                    method,
                    callbackId,
                    data,
                }));
            } catch (error) {
                reject(error);
            }

        }

    });
};

